import { safeTrim } from 'protocol-setup/helpers';
import React from 'react';
import { parse, format } from 'date-fns';

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const parsedDate = parse(dateStr, 'MM/dd/yyyy hh:mm:ss a', new Date());
      return format(parsedDate, 'dd-MMM-yyyy hh:mm:ss a');
    } catch (error) {
      return dateStr;
    }
  };


const CommentsUnderLabel = ({ commentsUnderLabel }) => {


  return (
    <ul className="pl-1">
      {
        [...commentsUnderLabel].reverse().map((c) => c.comments && <li className="d-block mb-1">{safeTrim(c.comments)}&nbsp;<span className="font-italic">({safeTrim(c.submitBy)}) {formatDate(safeTrim(c.submitDate))}</span></li>)
      }
    </ul>
  );
};

export default CommentsUnderLabel;

